import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/youhuiquan.png'
import _imports_1 from '@/assets/image/chilunbi.png'
import _imports_2 from '@/assets/image/yishiyong.png'
import _imports_3 from '@/assets/image/guoqi.png'
import _imports_4 from '@/assets/image/chilunbi2.png'


const _withScopeId = n => (_pushScopeId("data-v-3c12a330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "group"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img1"
}, null, -1))
const _hoisted_4 = { class: "newuser" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "购买立减", -1))
const _hoisted_6 = { class: "time" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "img2"
}, null, -1))
const _hoisted_8 = { class: "money" }
const _hoisted_9 = { class: "go" }
const _hoisted_10 = {
  key: 1,
  class: "group"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "img1"
}, null, -1))
const _hoisted_12 = { class: "newuser" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "购买立减", -1))
const _hoisted_14 = { class: "time" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "img2"
}, null, -1))
const _hoisted_16 = { class: "money" }
const _hoisted_17 = { class: "go" }
const _hoisted_18 = {
  key: 2,
  class: "past"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "img1"
}, null, -1))
const _hoisted_20 = { class: "newuser" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "购买立减", -1))
const _hoisted_22 = { class: "time" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "img2"
}, null, -1))
const _hoisted_24 = { class: "money" }
const _hoisted_25 = { class: "go" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CouponList, (coupon, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (coupon.status=='正常')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(coupon.title), 1),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, "有效期:" + _toDisplayString(coupon.from) + "至" + _toDisplayString(coupon.to), 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(coupon.amount), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(coupon.status) + " 》", 1)
            ]))
          : _createCommentVNode("", true),
        (coupon.status=='已使用')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(coupon.title), 1),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, "有效期:" + _toDisplayString(coupon.from) + "至" + _toDisplayString(coupon.to), 1),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(coupon.amount), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(coupon.status) + "    ", 1)
            ]))
          : _createCommentVNode("", true),
        (coupon.status=='已过期')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(coupon.title), 1),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, "有效期:" + _toDisplayString(coupon.from) + "至" + _toDisplayString(coupon.to), 1),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(coupon.amount), 1),
              _createElementVNode("div", _hoisted_25, _toDisplayString(coupon.status) + "    ", 1)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}